import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-492b2cb1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_2 = {
  key: 1,
  class: "user-focus-area__container"
}
const _hoisted_3 = {
  key: 0,
  class: "user-focus-area__name highlight"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "user-focus-area__action-items" }
const _hoisted_6 = { class: "user-focus-area__action-item" }

import { Ref, ref, watch } from 'vue'
import UserFocusAreaLoading from '@/components/FrontlineStaffDash/UserFocusAreaLoading.vue'
import DashboardCard from '@/components/FrontlineManagerDash/DashboardCard.vue'
import { faSquareCheck } from 'fontawesome/pro-regular-svg-icons'
import Checkbox from 'primevue/checkbox'
import { UserFocusArea } from '@/entities/frontlineStaffDash'

interface Props {
    onReloadClick?: Function
    focusArea?: UserFocusArea
    onActionAcknowledge: (actionId: string) => void
    loading: boolean
    showError?: boolean
    displayOnly?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UserFocusArea',
  props: {
    onReloadClick: { type: Function },
    focusArea: {},
    onActionAcknowledge: { type: Function },
    loading: { type: Boolean },
    showError: { type: Boolean },
    displayOnly: { type: Boolean }
  },
  setup(__props: any) {

const props = __props
const selectedActions: Ref<string[]> = ref([])

const setSelectedActions = () => {
    if (props.focusArea?.actions) {
        selectedActions.value = []
        props.focusArea?.actions.forEach((action) => {
            if (action.acknowledged) {
                selectedActions.value.push(action.id)
            }
        })
    }
}

watch(
    () => props.focusArea,
    () => {
        setSelectedActions()
    },
    { immediate: true }
)

const acknowledgeAction = (action: {
    id: string
    acknowledged?: boolean
    action_item: string
}) => {
    if (props.displayOnly) {
        return
    }
    props.onActionAcknowledge(action.id)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DashboardCard, {
    class: "card",
    icon: _unref(faSquareCheck),
    title: "Focus Area",
    "show-footer": false,
    "show-error": _ctx.showError,
    "on-reload-click": _ctx.onReloadClick
  }, {
    content: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(UserFocusAreaLoading)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (props.focusArea?.name)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, " \"" + _toDisplayString(props.focusArea?.name) + "\" ", 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, "There is no Focus Area set for your team.")),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.focusArea?.actions, (action) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: action.id
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_unref(Checkbox), {
                      modelValue: selectedActions.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedActions).value = $event)),
                      "input-id": action.id,
                      value: action.id,
                      pt: {
                                    box: {
                                        style: {
                                            'box-sizing': 'border-box',
                                            width: '16px',
                                            height: '16px',
                                        },
                                    },
                                },
                      class: "user-focus-area__action-checkbox",
                      disabled: !!action.acknowledged,
                      readonly: props.displayOnly,
                      onChange: () => acknowledgeAction(action)
                    }, null, 8, ["modelValue", "input-id", "value", "disabled", "readonly", "onChange"]),
                    _createTextVNode(" " + _toDisplayString(action.action_item), 1)
                  ])
                ]))
              }), 128))
            ])
          ]))
    ]),
    _: 1
  }, 8, ["icon", "show-error", "on-reload-click"]))
}
}

})